/* eslint-disable @typescript-eslint/no-shadow */
import { Action } from '@ngrx/store';
import { CountryAndLanguage } from '../../models/country-and-language.model';

export enum ActionTypes {
    GetCountriesAndLanguages                 = '[User Management] - Get countries and languages',
    GetCountriesAndLanguagesComplete         = '[User Management] - Get countries and languages complete'}

export class GetCountriesAndLanguages implements Action {
    readonly type = ActionTypes.GetCountriesAndLanguages;
    constructor(public payload?: {reload: boolean}) {}
}

export class GetCountriesAndLanguagesComplete implements Action {
    readonly type = ActionTypes.GetCountriesAndLanguagesComplete;
    constructor(public payload: CountryAndLanguage) {}
}

export type UserManagementActions =
  | GetCountriesAndLanguages
  | GetCountriesAndLanguagesComplete;
